import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import Heading from "../Heading/Heading"
import Time from "./Time/time"

import classes from "./schedule.module.scss"

const Schedule = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "horarios.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `)

  return (
    <section className={classes.Schedule}>
      <div className={classes.Content} id="schedule">
        <Heading>Horarios</Heading>
        <div className={classes.Times}>
          <Time
            period="mañana"
            days="Lunes a Viernes"
            hours="7:30hs - 12:00hs"
          />
          <Time
            period="tarde"
            days="Lunes a Viernes"
            hours="18:00hs - 20:00hs"
          />
        </div>
      </div>

      <Img
        className={classes.Background}
        fluid={data.image.childImageSharp.fluid}
        alt="Fondo horarios"
        fadeIn={false}
      />
    </section>
  )
}

export default Schedule
